import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { filmPicks } from "@/data/films";

export default function FilmPicks() {
  return (
    <section className="container-page py-14 md:py-20">
      <SectionHeading
        eyebrow="相关推荐"
        title="同样把情感藏在细节里的六部电影"
        description="如果你喜欢克制的表达、暗涌的关系和讲究的年代质感，这几部可以接着看。"
        actionLabel="进入专题合辑"
        actionTo="/special"
      />

      <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5">
        {filmPicks.map((film) => (
          <Link
            key={film.id}
            to="/special#films"
            className="group surface-card overflow-hidden transition-colors hover:border-accent-500/60"
          >
            <div className="relative aspect-[7/10] w-full overflow-hidden">
              <img
                src={film.cover}
                alt={`${film.title} 推荐封面`}
                title={`${film.title} ${film.genre} 影视推荐`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent" />
              <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-md bg-background-50/75 px-2 py-0.5 font-label text-[11px] text-accent-400 backdrop-blur">
                <i className="ri-star-fill text-[10px] leading-none" />
                {film.rating}
              </span>
              <div className="absolute inset-x-3 bottom-3">
                <p className="font-heading text-base text-foreground-950">{film.title}</p>
                <p className="mt-1 font-label text-[11px] text-foreground-600">
                  {film.year} · {film.region} · {film.genre}
                </p>
              </div>
            </div>
            <p className="line-clamp-2 px-3 py-3 text-xs leading-relaxed text-foreground-600 md:px-4">
              {film.reason}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}